import React, { useState, useEffect } from "react";
import { GoogleMap, useJsApiLoader, Marker, Polyline, DirectionsRenderer } from "@react-google-maps/api";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux'
import { GetInstituteAddressInformation } from "../../Actions/StudentA";

// const InstituteLocation = () => {
// const { isLoaded } = useJsApiLoader({
//     googleMapsApiKey: "AIzaSyCWiF-rhJC5vG-_6akKZbSiJ1AIRxJe_mI", // Replace with your actual API key
//     libraries: ["places", "geocoding"], // Add geocoding library
//     });

//   const [map, setMap] = useState(null);
//   const { InstituteId } = useParams();
//   console.log("InstituteId in useparams is:",InstituteId);
//   const dispatch = useDispatch();
//   const[instituteDBAddress, setInstituteDBAddress]= useState("")
//   const [userLocation, setUserLocation] = useState(null);
//   const [location, setLocation] = useState({ lat: 37.7749, lng: -122.4194 }); // Default: San Francisco
//   const [marker, setMarker] = useState(null);
//   const [studentMarker, setStudentMarker] = useState(null);

//   const { InstituteAddress } = useSelector((Store) => Store.StudentReducer);
//   console.log("InstituteAddress in InstituteLocation is:",InstituteAddress);

//   useEffect(() => {
//     if(InstituteId){
//         dispatch(GetInstituteAddressInformation(InstituteId))  
//     }
//   }, [dispatch, InstituteId]);

//   // Get User's Live Location
//   useEffect(() => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           setUserLocation({
//             lat: position.coords.latitude,
//             lng: position.coords.longitude,
//           });
//         },
//         (error) => {
//           console.error("Error getting user location:", error);
//         }
//       );
//     }
//   }, []);

//   useEffect(() => {
//     if (InstituteAddress) {
//       const address = InstituteAddress?.instituteDetails?.address;
//       setInstituteDBAddress(address);

//       if (address) {
//         // Delay execution slightly after API loads
//         setTimeout(() => {
//           geocodeAddress(address);
//         }, 500);
//       }
//     }
//   }, [InstituteAddress]);

//    // Function to convert address to lat/lng using Google Geocoding API
//   const geocodeAddress = (address) => {
//     if (!isLoaded || !window.google || !window.google.maps) {
//       console.error("Google Maps API is not fully loaded yet.");
//       return;
//     }

//     const geocoder = new window.google.maps.Geocoder();
//     geocoder.geocode({ address }, (results, status) => {
//       if (status === "OK" && results[0]?.geometry?.location) {
//         setLocation({
//           lat: results[0].geometry.location.lat(),
//           lng: results[0].geometry.location.lng(),
//         });
//       } else {
//         console.error("Geocoding failed: ", status);
//       }
//     });
//   };

//    // Function to update marker
//    const updateMarker = (coordinates, userLocation) => {
//     if (marker) marker.setMap(null); // Remove previous marker
//     if (studentMarker) studentMarker.setMap(null); // Remove student marker if exists
  
//     const newMarker = new window.google.maps.Marker({
//       position: coordinates,
//       map: map,
//       title: "Institute Location",
//       icon: {
//         url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png", // Change to red for better visibility
//       },
//     });
  
//     setMarker(newMarker);
  
//     if (userLocation) {
//       const newStudentMarker = new window.google.maps.Marker({
//         position: userLocation,
//         map: map,
//         title: "Student Location",
//         icon: {
//           url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
//         },
//       });
  
//       setStudentMarker(newStudentMarker);
//     }
//   };
  
//   useEffect(() => {
//     if (map) {
//       updateMarker(location, userLocation);
//     }
//   }, [map, location, userLocation]);

//   return (
//     <>
//       {!isLoaded ? (
//         <p>Map is loading...</p>
//       ) : (
//         <GoogleMap
//           mapContainerStyle={{ width: "100%", height: "100vh" }}
//           center={userLocation || location || { lat: 37.7749, lng: -122.4194 }} // Default SF
//           zoom={14}
//           onLoad={(mapInstance) => setMap(mapInstance)}
//         >

//           {/* Draw Polyline */}
//           {userLocation && location && (
//             <Polyline
//               path={[userLocation, location]}
//               options={{
//                 strokeColor: "#FF0000",
//                 strokeOpacity: 1.0,
//                 strokeWeight: 4,
//               }}
//             />
//           )}
//         </GoogleMap>
//       )}
//     </>
//   );
// };

const InstituteLocation = () => {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCWiF-rhJC5vG-_6akKZbSiJ1AIRxJe_mI",
    libraries: ["places", "geocoding"],
  });

  const [map, setMap] = useState(null);
  const { InstituteId } = useParams();
  const dispatch = useDispatch();
  const [instituteDBAddress, setInstituteDBAddress] = useState("");
  const [userLocation, setUserLocation] = useState(null);
  const [location, setLocation] = useState(null); // Initially null
  const [marker, setMarker] = useState(null);
  const [studentMarker, setStudentMarker] = useState(null);
  const [directions, setDirections] = useState(null);

  const { InstituteAddress } = useSelector((Store) => Store.StudentReducer);

  useEffect(() => {
    if (InstituteId) {
      dispatch(GetInstituteAddressInformation(InstituteId));
    }
  }, [dispatch, InstituteId]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Error getting user location:", error);
        }
      );
    }
  }, []);

  useEffect(() => {
    if (InstituteAddress) {
      const address = InstituteAddress?.instituteDetails?.address;
      setInstituteDBAddress(address);

      if (address && isLoaded) {
        geocodeAddress(address);
      }
    }
  }, [InstituteAddress, isLoaded]);

  const geocodeAddress = (address) => {
    if (!isLoaded || !window.google || !window.google.maps) {
      console.error("Google Maps API is not fully loaded yet.");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      if (status === "OK" && results[0]?.geometry?.location) {
        const newLocation = {
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        };

        setLocation(newLocation); // Ensure update triggers re-render
      } else {
        console.error("Geocoding failed: ", status);
      }
    });
  };

  useEffect(() => {
    if (map && userLocation && location) {
      updateMarker(location, userLocation);
      getDirections(userLocation, location);
    }
  }, [map, location, userLocation]);

  const updateMarker = (coordinates, userLocation) => {
    if (!map) return; // Ensure map is initialized before updating markers

    if (marker) marker.setMap(null);
    if (studentMarker) studentMarker.setMap(null);

    const newMarker = new window.google.maps.Marker({
      position: coordinates,
      map: map,
      title: "Institute Location",
      icon: {
        url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
      },
    });

    setMarker(newMarker);

    if (userLocation) {
      const newStudentMarker = new window.google.maps.Marker({
        position: userLocation,
        map: map,
        title: "Student Location",
        icon: {
          url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
        },
      });

      setStudentMarker(newStudentMarker);
    }
  };

  const getDirections = (origin, destination) => {
    if (!window.google || !window.google.maps || !window.google.maps.DirectionsService) {
      console.error("Google Maps Directions API is not available.");
      return;
    }

    const directionsService = new window.google.maps.DirectionsService();

    directionsService.route(
      {
        origin,
        destination,
        travelMode: window.google.maps.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK") {
          setDirections(result);
        } else {
          console.error("Directions request failed:", status);
        }
      }
    );
  };

  return (
    <>
      {!isLoaded ? (
        <p>Map is loading...</p>
      ) : (
        <GoogleMap
          mapContainerStyle={{ width: "100%", height: "100vh" }}
          center={userLocation || location || { lat: 37.7749, lng: -122.4194 }}
          zoom={14}
          onLoad={(mapInstance) => setMap(mapInstance)}
        >
          {directions && <DirectionsRenderer directions={directions} />}
        </GoogleMap>
      )}
    </>
  );
};


export default InstituteLocation;
